export default __webpack_public_path__ + "static/media/cool_4.968adc1a.jpg";